/* eslint-disable*/
import { Outlet, useLocation } from 'react-router-dom'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import {
  AuthCarouselDesktop,
  AuthCarouselMobile,
  darkGridStyle,
} from '../Components/Auth/AuthCarousel'
import env from '../env/env'
import { useThemeMode } from '../Provider/ThemeContextProvider'

const LegalFooter = () => {
  return (
    <div className='relative z-10 mt-8 rounded-t-[24px] border border-[#2a2d45] border-b-transparent bg-[#12142a]/80 px-4 pb-1 pt-4 font-IBM'>
      <p className='text-center text-[10px] font-medium leading-3 text-black-300'>
        <svg
          width='12'
          height='12'
          viewBox='0 0 24 24'
          fill='none'
          aria-hidden='true'
          className='mr-1 inline-block align-[-2px]'
        >
          <path
            d='M17 8h-1V6a4 4 0 1 0-8 0v2H7a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2zm-6-2a2 2 0 1 1 4 0v2h-4V6zm3 9.7V17a1 1 0 1 1-2 0v-1.3a2 2 0 1 1 2 0z'
            fill='#8b90b0'
          />
        </svg>
        Fabits Capital Services LLP | BSE Member ID 61731 | ARN - 344673 REGISTERED WITH AMFI
      </p>
      <p className='mt-1 text-center text-[10px] font-semibold text-primary-500'>
        <a
          href='https://start.fabits.com/termsandconditions'
          target='_blank'
          rel='noreferrer'
          className='no-underline'
        >
          Terms & Conditions
        </a>
        <span className='mx-1.5 text-black-300'>|</span>
        <a
          href='https://start.fabits.com/privacypolicy'
          target='_blank'
          rel='noreferrer'
          className='no-underline'
        >
          Privacy Policy
        </a>
      </p>
    </div>
  )
}

const LoginContainer = () => {
  const location = useLocation()
  const { darkMode } = useThemeMode()
  const logoSrc = darkMode ? `${env.SVGS}/newlogo.svg` : `${env.SVGS}/newlogo2.svg`
  // Mobile auth always uses the login dark logo on the shared dark grid background
  const mobileLogoSrc = `${env.SVGS}/newlogo.svg`
  const isLoginPage = location.pathname === '/login' || location.pathname === '/'
  const isSignUpPage = location.pathname === '/sign-up'
  // OTP + signup sit on the shared dark mobile grid (no light sheet)
  const isDarkMobileAuthForm =
    isSignUpPage ||
    location.pathname === '/otp' ||
    location.pathname === '/activate-account-otp' ||
    location.pathname === '/otp-login'

  return (
    <>
      {/* Mobile — same dark grid background as login across full auth flow */}
      <div className='relative flex h-[100svh] min-h-[100svh] w-full max-w-full flex-col overflow-hidden bg-[#040313] lg:hidden'>
        <div
          aria-hidden='true'
          className='pointer-events-none absolute inset-0 z-0 opacity-70'
          style={darkGridStyle}
        />

        {isLoginPage ? (
          <>
            <div className='relative z-10 flex min-h-0 flex-1 flex-col'>
              <div className='absolute inset-x-0 top-0 z-30 flex h-20 shrink-0 items-center justify-center bg-gradient-to-b from-[#040313] via-[#040313]/85 to-transparent pt-[env(safe-area-inset-top)]'>
                <img src={mobileLogoSrc} alt='fabits' className='h-16' />
              </div>
              <AuthCarouselMobile />
            </div>

            <div className='relative z-20 w-full shrink-0 rounded-t-[32px] bg-white/95 shadow-[0_-24px_70px_rgba(4,3,19,0.22)] backdrop-blur-[2px] dark:bg-[var(--fb-surface)]/95'>
              <div className='px-4 pb-[calc(16px+env(safe-area-inset-bottom))] pt-5'>
                <div className='mx-auto w-full max-w-[390px]'>
                  <Outlet />
                  <LegalFooter />
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className='relative z-10 flex h-full min-h-0 w-full flex-col'>
            {!isSignUpPage && (
              <div className='flex shrink-0 items-center justify-center px-4 pb-2 pt-[calc(16px+env(safe-area-inset-top))]'>
                <img src={mobileLogoSrc} alt='fabits' className='h-16' />
              </div>
            )}
            <div
              className={`min-h-0 flex-1 overflow-y-auto overflow-x-hidden px-4 pb-[calc(16px+env(safe-area-inset-bottom))] ${isSignUpPage ? 'pt-[calc(16px+env(safe-area-inset-top))]' : 'pt-2'
                }`}
            >
              <div
                className={`mx-auto flex min-h-full w-full max-w-[390px] flex-col py-4 ${isDarkMobileAuthForm
                  ? ''
                  : 'rounded-[32px] bg-white/95 px-4 py-6 shadow-[0_-24px_70px_rgba(4,3,19,0.22)] backdrop-blur-[2px] dark:bg-[var(--fb-surface)]/95'
                  }`}
              >
                <div className='flex flex-1 flex-col justify-center'>
                  <Outlet />
                </div>
                <LegalFooter />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Desktop — two equal-height columns: carousel | auth */}
      <div className='hidden h-screen max-h-screen w-full lg:grid lg:grid-cols-2'>
        <div className='h-full min-h-0 w-full overflow-hidden'>
          <AuthCarouselDesktop />
        </div>
        <div className='relative flex h-full min-h-0 flex-col justify-between overflow-y-auto p-12'>
          {!isSignUpPage && (
            <div className='my-3 flex justify-end'>
              <img src={logoSrc} alt='Fabits' className='h-16' />
            </div>
          )}
          <div className='flex flex-1 flex-col justify-center'>
            <Outlet />
          </div>
          <LegalFooter />
        </div>
      </div>
    </>
  )
}

export default LoginContainer
